module.exports = __webpack_public_path__ + "img/order.a943ebe6.png";